import Adicionar from './Adicionar';
import Editar from './Editar';
import Lista from './Lista';

export const QuizAdicionar = Adicionar;
export const QuizEditar = Editar;
export const QuizLista = Lista;
